/**
 * Location API service — city search via Geonames/local fallback.
 */
import { AxiosResponse } from 'axios';
import { BaseApiService } from './baseApi';
import { LOCATIONS, SEARCH } from '../../constants';
import { Location } from '../../types';
import { ServiceResult } from '../../types/common/api.types';

export class LocationApiService extends BaseApiService {
  async searchLocations(name: string): Promise<ServiceResult<Location[]>> {
    return this.withErrorHandling(async () => {
      const response: AxiosResponse<Location[]> = await this.api.get(
        `${LOCATIONS}${SEARCH}?name=${encodeURIComponent(name)}`
      );
      return response.data;
    });
  }
}
